import React, {useState} from "react";
import {
    Datagrid,
    FunctionField,
    ReferenceManyField,
    SelectField,
    TextField,
    useDataProvider,
    useGetRecordId,
    useNotify
} from "react-admin";
import {convertedDateWithTimeGMT} from "../../../Functions/ConvertedDate";
import PaginationMod from "../../../Component/Redesign/PaginationMod";
import ConfirmModal from "../../../Component/Redesign/Confirm";

const Purchases = (props) => {
    const classes = props.classes;
    const [openDisableDialog, setDisableDialogOpen] = useState(false);
    const recordId = useGetRecordId();
    const dataProvider = useDataProvider();
    const notify = useNotify();

    const handleConfirm = () => {
        dataProvider.getOne(`customer`, {id: `${recordId}/subscriptions/synchronization`}).then(() => {
            setDisableDialogOpen(false);
            notify('Finished!', {type: 'success'});
        }).catch((err) => {
            setDisableDialogOpen(false);
            notify(err.message, {type: 'warning'});
        });
    };

    return (
        <>
            <div className={classes.listWrap}>
                <div className='edit-btns-user-wrap'>
                    <button className="button gradient-button " type="button" onClick={() => setDisableDialogOpen(true)}>Synchronization</button>
                    <ConfirmModal
                        isOpen={openDisableDialog}
                        title={`Synchronization`}
                        content={`Are you sure you want to synchronise purchases with subscriptions?`}
                        onConfirm={() => {handleConfirm()}}
                        onClose={() => {setDisableDialogOpen(false)}}
                        type={'enable'}
                    />
                </div>
                <ReferenceManyField reference="purchases/" target="customer_id" perPage={50} pagination={<PaginationMod />} sort={{field: 'updated_at', order: 'DESC'}}>
                    <Datagrid bulkActionButtons={false}>
                        <FunctionField label='Date (GMT)' source="updated_at" sortBy="updated_at" render={(record) => {
                            return <span>{convertedDateWithTimeGMT(record.updated_at)}</span>
                        }}/>
                        <TextField label='Product ID' source="product" sortBy="product"/>
                        <SelectField source="verified" label="Verified" choices={[
                            {id: 0, name: 'No'},
                            {id: 1, name: 'Yes'}
                        ]}/>
                        <SelectField source="platform" label="Platform" choices={[
                            {id: null, name: '-'},
                            {id: 1, name: 'Android'},
                            {id: 2, name: 'iOS'}
                        ]}/>
                        <SelectField source="trial" label="Trial" choices={[
                            {id: 0, name: 'No'},
                            {id: 1, name: 'Yes'}
                        ]}/>
                        <FunctionField label="Notification Type" source="notification_type" render={(record) => {
                            return (record.notification_type ? record.notification_type : '-');
                        }}/>
                        <SelectField source="submitted_by_admin" label="Submitted By Admin" choices={[
                            {id: 0, name: 'No'},
                            {id: 1, name: 'Yes'}
                        ]}/>
                    </Datagrid>
                </ReferenceManyField>
            </div>
        </>
    );
};

export default Purchases;